module.exports = __webpack_public_path__ + "static/media/error.74a15276.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/toast/error.png
// module id = 491
// module chunks = 0